<ion-header class="ion-no-border">
    <ion-toolbar>

        <ion-buttons slot="start">
            <ion-button (click)="close()">
                <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>

        <ion-title>Sell gift voucher</ion-title>

        <ion-buttons slot="end">
            <ion-button (click)="validateInput()">
                <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>

    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-grid class="form">
        <ion-row>
            <ion-col>

                <ion-grid class="fieldset">
                    <ion-row>
                        <ion-col>
                            <ion-input type="text" inputmode="text" maxlength="20" label="Code" labelPlacement="stacked" fill="outline" [(ngModel)]="code"></ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input #amount_input type="tel" inputmode="decimal" maxlength="10" autocomplete="new-amount" label="Amount" labelPlacement="stacked" fill="outline" [(ngModel)]="amount"></ion-input>
                        </ion-col>
                    </ion-row>
                </ion-grid>

            </ion-col>
        </ion-row>
    </ion-grid>
</ion-content>